module.exports = __webpack_public_path__ + "img/ic_status_end.5dbd1401.svg";